module.exports = __webpack_public_path__ + "static/media/asset22.cbc621c0.jpg";